"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
export default function LocationMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className={`relative w-full h-[70vh] overflow-hidden transition-opacity duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.2!2d-79.9959!3d40.4406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI2JzI2LjIiTiA3OcKwNTknNDUuMiJX!5e0!3m2!1sen!2sus!4v1234567890" className="absolute inset-0 w-full h-full border-0 brightness-75" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="K&M Mechanical Services Location" />

      {}
      <div className="absolute inset-0 bg-dark-background/30 pointer-events-none" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full z-10 flex flex-col items-center">
        <div className="relative">
          {}
          <div className="absolute inset-0 rounded-full bg-primary animate-ping motion-reduce:animate-none opacity-75" style={{
          animationDuration: "2s"
        }} />
          
          {}
          <div className="relative bg-primary text-foreground-primary rounded-full p-3 shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-110 hover:shadow-[0_12px_40px_rgb(0_0_0_/_0.24)] motion-reduce:hover:scale-100 motion-reduce:bg-primary-hover">
            <MapPin className="w-6 h-6" />
          </div>
        </div>

        {}
        <div className="mt-3 bg-background/95 backdrop-blur-sm px-4 py-2 rounded-md shadow-medium">
          
        </div>
      </div>
    </section>;
}